import React from "react";
import PropTypes from "prop-types";
import { CardContent, CardHeader, Typography } from "@mui/material";
import ReactApexChart from "react-apexcharts";

import { chartColors } from "common/constant";
import { pick } from "lodash";

const NumberOfComplaintsPieChart = ({
  data,
  complaintTitleIndex,
  complaintTitle,
}) => {
  const labels = [
    "Within 50% of stipulated time",
    "Within stipulated time",
    "Upto double the stipulated time",
    "More than double the stipulated time",
    "Balance complaints to be redressed",
  ];

  const filteredSeries = pick(data, [
    "Within 50% of stipulated time",
    "Within stipulated time",
    "Upto double the stipulated time",
    "More than double the stipulated time",
    "Balance complaints to be redressed",
  ]);

  const series = Object.values(filteredSeries).map(
    (data) => data[complaintTitleIndex]
  );

  const options = {
    chart: {
      width: 300,
      type: "donut",
    },
    fill: {
      type: "gradient",
    },
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            total: {
              showAlways: true,
              show: true,
            },
          },
        },
      },
    },
    labels: labels,
    dataLabels: {
      style: {
        color: "#000",
      },
    },
    legend: {
      position: "bottom",
      horizontalAlign: "left",
      onItemClick: {
        toggleDataSeries: true,
      },
      onItemHover: {
        highlightDataSeries: false,
      },
      formatter: (seriesName, opts) => [
        seriesName,
        " - ",
        opts.w.globals.series[opts.seriesIndex],
      ],
    },
    colors: chartColors,
  };

  return (
    <>
      <CardHeader
        title={
          <Typography variant="subtitle1" fontWeight={700}>
            {complaintTitle}
          </Typography>
        }
      />
      <CardContent>
        <ReactApexChart
          options={options}
          series={series}
          type="donut"
          height={470}
        />
      </CardContent>
    </>
  );
};

NumberOfComplaintsPieChart.propTypes = {
  data: PropTypes.object,
  complaintTitleIndex: PropTypes.number,
  complaintTitle: PropTypes.string,
};

export default NumberOfComplaintsPieChart;
